import {
  LabelBinding,
  RequestDataOfCreateOrderRequest,
  RequestDataOfGetOffersRequest,
  RequestDataOfGetTermsAndConditionsRequest,
  ResponseDataOfCreateOrderResponse,
  ResponseDataOfGetOffersResponse,
  ResponseDataOfGetTermsAndConditionsResponse,
} from '@monorepo-types/dc/smartthermostat';

import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

type CreateOrderV2 = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  requestBody: RequestDataOfCreateOrderRequest;
};
/**
 *
 *
 * @returns ResponseDataOfCreateOrderResponse OK
 */
export function createOrderV2(
  { businessUnit, label, customerId, accountId, requestBody }: CreateOrderV2,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfCreateOrderResponse> {
  return request(
    {
      method: 'POST',
      path: `/v1/smartthermostat/v2/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/sales/orders`,
      body: requestBody,
      errors: { 400: 'Bad Request', 403: 'Forbidden', 404: 'Not Found', 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}

type GetTermsAndConditions = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  requestBody: RequestDataOfGetTermsAndConditionsRequest;
};
/**
 *
 *
 * @returns ResponseDataOfGetTermsAndConditionsResponse OK
 */
export function getTermsAndConditions(
  { businessUnit, label, customerId, accountId, requestBody }: GetTermsAndConditions,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfGetTermsAndConditionsResponse> {
  return request(
    {
      method: 'POST',
      path: `/v1/smartthermostat/v2/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/sales/termsandconditions/query`,
      body: requestBody,
      errors: { 400: 'Bad Request', 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}

type GetOffersV2 = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  requestBody: RequestDataOfGetOffersRequest;
};
/**
 *
 *
 * @returns ResponseDataOfGetOffersResponse OK
 */
export function getOffersV2(
  { businessUnit, label, customerId, accountId, requestBody }: GetOffersV2,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfGetOffersResponse> {
  return request(
    {
      method: 'POST',
      path: `/v1/smartthermostat/v2/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/sales/offers/query`,
      body: requestBody,
      errors: { 400: 'Bad Request', 404: 'Not Found', 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}
